module.exports = __webpack_public_path__ + "img/big_img_1.36a539d5.jpg";